/* eslint-disable @typescript-eslint/consistent-type-assertions,@typescript-eslint/no-non-null-assertion */
import { RadioButton, RadioButtonGroup } from "@octopusdeploy/design-system-components";
import type { ActionTemplateParameterResource } from "@octopusdeploy/octopus-server-client";
import { ControlType, PackageSelectionMode } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { StepTemplatesParameterSelector } from "~/areas/library/components/StepTemplates/StepTemplatesParameterSelector";
import { ProcessTemplatesParameterSelector } from "~/areas/platformHub/processEditor/ProcessTemplatesParameterSelector";
import { useOptionalProducerProcessTemplateContext } from "~/areas/projects/components/Process/ProcessTemplates/ProducerProcessTemplateContext";
import BaseComponent from "~/components/BaseComponent";
import { Note } from "~/components/form";
import type { PackageSelectorProps } from "./PackageSelector";
import PackageSelector from "./PackageSelector";
interface DeferredPackageSelectorProps extends PackageSelectorProps {
    packageSelectionMode: PackageSelectionMode;
    packageSelectionModeError?: string;
    parameters?: ActionTemplateParameterResource[];
    packageParameterName: string;
    packageParameterError?: string;
    onPackageSelectionModeChange(value: PackageSelectionMode): void;
    onPackageParameterChange(value: string): void;
    isProcessTemplateProcess?: boolean;
}
export default class DeferredPackageSelector extends BaseComponent<DeferredPackageSelectorProps> {
    constructor(props: DeferredPackageSelectorProps) {
        super(props);
    }
    render() {
        return <Selector {...this.props}/>;
    }
    static displayName = "DeferredPackageSelector";
}
function Selector(props: DeferredPackageSelectorProps) {
    const producerProcessTemplateContext = useOptionalProducerProcessTemplateContext();
    if (props.projectId && !producerProcessTemplateContext?.processTemplate) {
        return <PackageSelector {...props}/>;
    }
    const packageSelectionMode = props.packageSelectionMode || PackageSelectionMode.Immediate;
    const onChange = (value: PackageSelectionMode) => props.onPackageSelectionModeChange(value);
    const processTemplateParameters = producerProcessTemplateContext?.processTemplate.Parameters || [];
    if (props.isProcessTemplateProcess && packageSelectionMode === PackageSelectionMode.Deferred) {
        return <PackageParameterSelector {...{ ...props, processTemplateParameters }}/>;
    }
    return (<RadioButtonGroup value={packageSelectionMode} error={props.packageSelectionModeError} onChange={onChange}>
            {<RadioButton value={PackageSelectionMode.Immediate} label="Select specific package"/>}
            {packageSelectionMode === PackageSelectionMode.Immediate && <PackageSelector {...props}/>}
            {<RadioButton value={PackageSelectionMode.Deferred} label="Let the project select the package"/>}
            {packageSelectionMode === PackageSelectionMode.Deferred && <PackageParameterSelector {...{ ...props, processTemplateParameters }}/>}
        </RadioButtonGroup>);
}
function PackageParameterSelector(props: DeferredPackageSelectorProps) {
    const noteText = props.isProcessTemplateProcess ? "When using this process template in a project, the user will be prompted to select a package." : "When using this step template in a process, the user will be prompted to select a package.";
    return (<div>
            {props.isProcessTemplateProcess ? (<ProcessTemplatesParameterSelector selectedParameter={props.packageParameterName || null} onParameterChange={(value) => props.onPackageParameterChange(value || "")} controlType={ControlType.Package} allowClear={true} error={props.packageParameterError} bindValue={false}/>) : (<StepTemplatesParameterSelector selectedParameter={props.packageParameterName || null} onParameterChange={(value) => props.onPackageParameterChange(value || "")} controlType={ControlType.Package} allowClear={true} error={props.packageParameterError} parameters={props.parameters || []}/>)}
            <Note>{noteText}</Note>
        </div>);
}
